import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IconsProviderModule } from './icons-provider.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData, CurrencyPipe, CommonModule } from '@angular/common';
import en from '@angular/common/locales/en';
import { HomeComponent } from './home/home.component';
import { PassResetComponent } from './shared-components/shared/pass-reset/pass-reset.component';
// import { NgZorroAntdModule } from 'ng-zorro-antd';
import { HttpConfigInterceptor } from './core/interceptor/Interceptors';
import { DynamicModule } from 'ng-dynamic-component';
import { NgxSpinnerModule } from "ngx-spinner";
import { TagInputModule } from 'ngx-chips';
import { CurrencyInputDirective } from './core/directive/currency-input.directive';
import { UppercaseInputDirective } from './core/directive/uppercase.directive';
import { NumberDirective } from './core/directive/numbers-only.directive';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { ChartsModule } from 'ng2-charts';


registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent, HomeComponent, PassResetComponent
  ],
  imports: [
    CommonModule,
    TagInputModule,
    BrowserModule,
    AppRoutingModule,
    IconsProviderModule,
    NzLayoutModule,
    NzMenuModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    NzModalModule,
    NzCardModule,
    NzFormModule,
    NzInputModule,
    NzAlertModule,
    NzMessageModule,
    NzResultModule,
    NzAutocompleteModule,
    NzTabsModule,
    NzAvatarModule,
    NzDropDownModule,
    NzDrawerModule,
    DynamicModule,
    ChartsModule,
  ],
  providers: [
    NumberDirective,
    UppercaseInputDirective,
    CurrencyPipe,
    NzMessageService,
    CurrencyInputDirective,
    { provide: NZ_I18N, useValue: en_US },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    },],
  bootstrap: [AppComponent]
})
export class AppModule { }
